import React, { Component } from 'react';
import { Card } from 'semantic-ui-react';

export const TechnicsReportShort = (props) => {
	
	const style = { width: "115px", height: "67px" };
	
	const d = props.data;
	
	const gear = d.gear ? "x" + d.gear : undefined;
	
	const alloywheels = d.alloywheels > 0 ? text.yes : text.no;
	
	let cc;
	
	if (d.electric)
	{
		cc = { color: "yellow", header: d.cc ? d.cc : "-", meta: "kWh", description: text.battery };
	}
	else
	{
		cc = { color: "yellow", header: d.cc ? d.cc : "-", description: "CC" };
	}
		
	const consumption = {
		color: "grey",
		header: d.consumption ? d.consumption : "-",
		meta: d.electric ? "kWh/100km" : "L/100km",
		description: text.consumption
	};
	
	const transmission = {
		color: "olive",
		header: d.transmission ? d.transmission : "-",
		meta: gear,
		description: text.transmission
	};
	
	const cards = [
		cc,
		{ color: "orange", header: d.hp ? d.hp : "-", description: "HP" },
		{ color: "red", header: d.acceleration ? d.acceleration : "-", meta: "sec", description: "0-100" },
		{ color: "brown", header: d.co2 ? d.co2 : "-", meta: "g/km", description: "CO2" },
		consumption,
		{ color: "blue", header: d.emission ? d.emission : "-", description: text.norm },
		transmission,
		{ color: "green", header: d.weight ? d.weight : "-", meta: "kg", description: text.weight },
		{ color: "teal", header: d.fuel ? d.fuel : "-" },
	];
	
	return (
		<Card.Group className="short" itemsPerRow={3}>
			{cards.map((c, i) => {
				
				const className = typeof c.meta == "undefined" ? "no-meta" : "";
				
				return (
					<Card
						key={i}
						color={c.color}
						className={className}
						style={style}
						header={c.header}
						meta={c.meta}
						description={c.description}
					/>
				);
			})}
		</Card.Group>
	);
}